import React, { useEffect, useState } from "react";
import { api, absUrl } from "../../lib/api";
import { Section, Eyebrow } from "../../components/public/Section";
import { PageHero } from "./About";

export default function Blog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/blogs").then(r => setItems(r.data)); }, []);
  return (
    <>
      <PageHero title="Journal" subtitle="Field notes from our kitchens, mandaps and tasting rooms." image="https://images.unsplash.com/photo-1681270543584-8e541a1bb056?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <Eyebrow>Latest Articles</Eyebrow>
        {items.length === 0 ? (
          <div className="text-navy-900/60 mt-6 max-w-xl">Our journal is being curated. Subscribe to our newsletter to be the first to read.</div>
        ) : (
          <div className="grid md:grid-cols-3 gap-6 mt-6">
            {items.map(b => (
              <div key={b.id} className="border border-navy-900/10 bg-white hover:border-gold transition" data-testid={`blog-${b.slug}`}>
                {b.cover_url && <img src={absUrl(b.cover_url)} className="w-full h-52 object-cover" alt={b.title} />}
                <div className="p-6">
                  <div className="label-eyebrow">{b.tag || "Stories"}</div>
                  <div className="serif text-2xl mt-2">{b.title}</div>
                  <p className="text-navy-900/60 text-sm mt-2 line-clamp-3">{b.excerpt}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </Section>
    </>
  );
}
